<template>
  <v-chip class="ml-2">
    {{ deviceName }}
    <status-indicator :status="status" class="ml-5" pulse right/>
  </v-chip>
</template>
<script>
import {StatusIndicator} from 'vue-status-indicator';

export default {
  components: {
    StatusIndicator
  },
  props: {
    deviceName: {
      type: String,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    deviceNumber: {
      type: Number,
      required: true
    }
  },
};
</script>
